export default {"src":"/_next/static/media/hellogreenfriends.f52f7179.svg","height":420,"width":2567};